import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router";
import { useCombobox } from "downshift";

import OptionallyDisplayed from "./optionallyDisplayed";
import MagnifySearchField from "../../../assets/svg/magnifySearchField.svg";
import X from "../../../assets/svg/x.svg";

export default function SearchBox({
  searched = null,
  setSearched,
  setSearching,
  search,
  onSuggestionsFetchRequested,
  suggestions,
  setSuggestions,
  showSearch = null,
  placeholder = "",
  catStyle = "",
  initialInputValue = "",
}) {
  const { pathname } = useLocation();
  const prevPath = useRef();

  const handleSearchSubmit = async (e, value) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (setSearching) {
      setSearching(true);
    }
    const found = await search(value);
    setSearched(found);
    if (setSearching) {
      setSearching(false);
    }
  };

  const { inputValue, isOpen, closeMenu, getMenuProps, getInputProps, highlightedIndex, getItemProps, setInputValue } =
    useCombobox({
      items: suggestions,
      onInputValueChange: ({ inputValue }) => {
        setInputValue(inputValue);
        onSuggestionsFetchRequested({ value: inputValue });
        if (inputValue.trim() === "") {
          setSearched(null);
        }
      },
      onStateChange: (changes) => {
        switch (changes.type) {
          case useCombobox.stateChangeTypes.ItemClick:
          case useCombobox.stateChangeTypes.InputKeyDownEnter:
            const input = changes.selectedItem || inputValue;
            handleSearchSubmit(null, input);
            break;
          default:
        }
      },
      initialInputValue,
    });

  const handleSearchClear = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    setInputValue("");

    if (searched?.length > 0) {
      setSearched(null);
      if (setSearching) {
        setSearching(false);
      }
      setSuggestions([]);
    }
  };

  const submitFormHandler = (e) => {
    closeMenu();
    handleSearchSubmit(e, inputValue);
  };

  useEffect(() => {
    if (prevPath.current !== pathname) {
      if (prevPath.current) {
        handleSearchClear();
      }
      prevPath.current = pathname;
    }
  }, [pathname]);

  return (
    <form onSubmit={submitFormHandler} className={`content-search-form${searched ? " searched" : ""} ${catStyle}`}>
      <div>
        <div>
          <input placeholder={placeholder} {...getInputProps()} />
        </div>
        <ul {...getMenuProps()} className="search-suggestions-container suggestions-list">
          {isOpen &&
            suggestions.map((item, index) => {
              return (
                <li
                  className={`suggestion${highlightedIndex === index ? " highlighted" : ""}`}
                  key={`${item}`}
                  {...getItemProps({ item, index })}
                >
                  {item}
                </li>
              );
            })}
        </ul>
      </div>

      <OptionallyDisplayed doDisplay={!!searched}>
        <button type="button" className="search-clear" onClick={handleSearchClear} data-testid="search-clear-button">
          <X />
        </button>
      </OptionallyDisplayed>

      <OptionallyDisplayed doDisplay={showSearch}>
        <button type="submit" className="search-submit" data-testid="search-submit">
          <MagnifySearchField />
        </button>
      </OptionallyDisplayed>
    </form>
  );
}
